import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MobileTooltipTriggerDirective } from '@shared/directives';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FitTextModule, FormFieldModule, TimerModule } from '@shared/components/games';
import { BeeControllerComponent } from './bee-controller/bee-controller.component';
import { BeeCorrectAnswerPreviewComponent } from './bee-preview/bee-answer-preview/bee-answer-preview.component';
import { BeeExamplePreviewComponent } from './bee-preview/bee-example-preview/bee-example-preview.component';
import { BeeParametersPreviewComponent } from './bee-preview/bee-parameters-preview/bee-parameters-preview.component';
import { BeeUserAnswerPreviewComponent } from './bee-preview/bee-user-answer-preview/bee-user-answer-preview.component';
import { BeeSettingsComponent } from './bee-settings/bee-settings.component';
import { BeeTableComponent } from './components/bee-table/bee-table.component';

@NgModule({
  declarations: [
    BeeControllerComponent,
    BeeSettingsComponent,
    BeeCorrectAnswerPreviewComponent,
    BeeExamplePreviewComponent,
    BeeParametersPreviewComponent,
    BeeUserAnswerPreviewComponent,
  ],
  exports: [
    BeeControllerComponent,
    BeeSettingsComponent,
    BeeCorrectAnswerPreviewComponent,
    BeeExamplePreviewComponent,
    BeeParametersPreviewComponent,
    BeeUserAnswerPreviewComponent,
  ],
  imports: [
    BeeTableComponent,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FitTextModule,
    TimerModule,
    MatTooltipModule, MobileTooltipTriggerDirective,
    GamesSharedModule,
    FormFieldModule,
  ],
})
export class BeeModule {}
